import { useQueryClient } from "@tanstack/react-query";
import {
  HOME_DOMAIN,
  HOME_MEDITATION_LIST_ENDPOINT,
  HOME_TASK_LIST_ENDPOINT,
  HOME_THOUGHTRECORD_LIST_ENDPOINT,
  MeditationItemType,
  ThoughtRecordItemType,
} from "api/homeApi";
import { CustomResponseFormat } from "api/instance";
import { TaskType } from "api/taskApi";
import { applyDoneToList } from "./applyDoneToList";

// 활동지·생각기록지·명상훈련지 홈 리스트 쿼리 캐시에 done/undone 을 낙관적으로 선반영.
// 홈 목록은 리더 replica 에서 읽어 완료 직후 재조회가 이전 isDone 을 돌려줄 수 있다.
// queryKey 는 patientId/userId 변형이 있을 수 있어 setQueriesData(2요소 prefix) 로 fuzzy 매칭.
export default function useOptimisticHomeListDone() {
  const queryClient = useQueryClient();

  const markTaskDone = (taskKey: string, isDone: boolean = true) => {
    const nowIso = new Date().toISOString();
    queryClient.setQueriesData<CustomResponseFormat<TaskType[]>>(
      [HOME_DOMAIN, HOME_TASK_LIST_ENDPOINT],
      (old) =>
        applyDoneToList(old, (t) => t.taskKey === taskKey, nowIso, isDone)
    );
  };

  const markThoughtRecordDone = (
    thoughtRecordKey: string,
    isDone: boolean = true
  ) => {
    const nowIso = new Date().toISOString();
    queryClient.setQueriesData<CustomResponseFormat<ThoughtRecordItemType[]>>(
      [HOME_DOMAIN, HOME_THOUGHTRECORD_LIST_ENDPOINT],
      (old) =>
        applyDoneToList(
          old,
          (t) => t.thoughtRecordKey === thoughtRecordKey,
          nowIso,
          isDone
        )
    );
  };

  const markMeditationRecordDone = (
    meditationRecordKey: string,
    isDone: boolean = true
  ) => {
    const nowIso = new Date().toISOString();
    queryClient.setQueriesData<CustomResponseFormat<MeditationItemType[]>>(
      [HOME_DOMAIN, HOME_MEDITATION_LIST_ENDPOINT],
      (old) =>
        applyDoneToList(
          old,
          (t) => t.meditationRecordKey === meditationRecordKey,
          nowIso,
          isDone
        )
    );
  };

  return { markTaskDone, markThoughtRecordDone, markMeditationRecordDone };
}
